export default "__VITE_ASSET__C9tL7HVl__"